import React from "react";
import Template1RC from "./Template1RC";
import Template2RC from "./Template2RC";
import Template3RC from "./Template3RC";
import Template4RC from "./Template4RC";
import Template5RC from "./Template5RC";
import Template6RC from "./Template6RC";
import Template7RC from "./Template7RC";

const RoadClosureTemplate = ({
  permitDetails,
  isSidebarExpanded,
  departmentApprovals,
}) => {
  const {
    checklistItems = [],
    commonFields = {},
    workDetails = [],
    form_data: formData = {},
    hazardsPrecautions = [{}],
    signatures = [],
    clearanceRenewal = [],
    permitClosure = {},
  } = permitDetails || {};

  const resolvedDepartmentApprovals =
    departmentApprovals?.length > 0
      ? departmentApprovals
      : permitDetails?.departmentApprovals || [];

  // Some fields are returned only by the saved work-details endpoint. Fill
  // gaps without letting empty values hide fields present in another source.
  const mergedWorkDetails = {};
  [
    permitDetails?.excavationWorkDetails,
    permitDetails?.permit_details?.[0],
    formData,
    commonFields,
    Array.isArray(workDetails) ? workDetails[0] : workDetails,
  ].forEach((source) => {
    Object.entries(source || {}).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== "") {
        mergedWorkDetails[key] = value;
      }
    });
  });
  const normalizedWorkDetails = [mergedWorkDetails];

  // console.log("formData in departmentApprovals:", departmentApprovals);

  // console.log("permitDetails in ColdWorkPermitTemplate:", permitDetails);
  // console.log("Checklist in ColdWorkPermitTemplate:", checklistItems); // Updated here
  // console.log("workDetails in ColdWorkPermitTemplate:", workDetails);
  // console.log("formData in ColdWorkPermitTemplate:", formData);

  return (
    // <div className="template-container">
    <div className="cs-work-template rc_permit-template">
      <div id="section1">
        <Template1RC workDetails={normalizedWorkDetails} />
        <Template2RC
          workDetails={normalizedWorkDetails}
          isSidebarExpanded={isSidebarExpanded}
        />
        <Template3RC
          checklist={checklistItems} // Passing checklistItems correctly
          isSidebarExpanded={isSidebarExpanded}
          departmentApprovals={resolvedDepartmentApprovals}
        />
        <Template4RC
          signatures={signatures}
          formData={formData}
          workDetails={normalizedWorkDetails}
          permitDetails={permitDetails}
          isSidebarExpanded={isSidebarExpanded}
        />
      </div>
      <div id="section2">
        <Template5RC
          hazardsPrecautions={hazardsPrecautions}
          isSidebarExpanded={isSidebarExpanded}
        />
        <Template6RC
          clearanceRenewal={clearanceRenewal}
          workDetails={normalizedWorkDetails}
          isSidebarExpanded={isSidebarExpanded}
        />
        <Template7RC
          permitClosure={permitClosure}
          workDetails={normalizedWorkDetails}
        />
      </div>
    </div>
    // </div>
  );
};

export default RoadClosureTemplate;
